var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('div',{staticClass:"main-content"},[_c('main-nav'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }